import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { AnalysisResultCategoriesActions } from '../actions';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.AnalysisResultCategory };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    AnalysisResultCategoriesActions.CreateAnalysisResultCategory,
    AnalysisResultCategoriesActions.ReadAnalysisResultCategory,
    AnalysisResultCategoriesActions.ReadAnalysisResultCategories,
    AnalysisResultCategoriesActions.UpdateAnalysisResultCategory,
    AnalysisResultCategoriesActions.DeleteAnalysisResultCategory,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    AnalysisResultCategoriesActions.CreateAnalysisResultCategorySuccess,
    AnalysisResultCategoriesActions.UpdateAnalysisResultCategorySuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    AnalysisResultCategoriesActions.ReadAnalysisResultCategoriesSuccess,
    (state, { response }) => {
      const items = response['hydra:member'];
      const entities = items.reduce(
        (
          entities: { [iri: string]: fromModuleModels.AnalysisResultCategory },
          item
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    AnalysisResultCategoriesActions.DeleteAnalysisResultCategorySuccess,
    (state, { iri }) => {
      const { [iri]: removedItem, ...entities }: any = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    AnalysisResultCategoriesActions.CreateAnalysisResultCategoryFail,
    AnalysisResultCategoriesActions.UpdateAnalysisResultCategoryFail,
    AnalysisResultCategoriesActions.DeleteAnalysisResultCategoryFail,
    state => {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
